import { Directive } from '@angular/core';
import { AbstractControl, Validator, NG_VALIDATORS } from '@angular/forms';

export class CustomValidators {


}

@Directive({
    selector: '[numericZeroToHundred]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: NumericZeroToHundred,
        multi: true
    }]
})
export class NumericZeroToHundred implements Validator {
    validate(control: AbstractControl): { [key: string]: any } | null {
        let reg = new RegExp('^[0-9]+$');
        if ((control.value || control.value == 0) && reg.test(control.value) && (control.value >= 0 && control.value <= 300)) {
            return null;
        }
        return { 'zoomPercentageInvalid': true };
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/directives/custom-validators.ts